import { useEffect } from 'react';
import { setCookie } from 'nookies';
import { useRouter } from 'next/router';
import API from '../../api';
import Tracking from '../../utils/tracking';

export const usePresistLocale = (): null => {
  const { locale } = useRouter();

  useEffect(() => {
    if (locale) {
      setCookie(null, 'NEXT_LOCALE', locale, { maxAge: 365 * 24 * 60 * 60, path: '/' });
      API.setLocale(locale);
      Tracking.setLocale(locale);
    }
  }, [locale]);

  return null;
};

export default usePresistLocale;
